<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="sticky-nav" ref="stickyNav">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />

        <div class="flex" style="margin-right: auto;">
          <header-profile
            v-if="hasUnderwritingExecutive"
            :name="underwritingExecutiveName"
            :role="underwritingExecutiveRole"
            :contactPK="underwriterExecutivePk"
            style="margin-right: 10px;"/>
          <header-profile
            v-if="hasAreaManager"
            :name="areaManagerName"
            :role="areaManagerRole"
            :contactPK="areaManagerPk" />
        </div>

        <div class="entity-name">
          <p>{{ pageTitle }}</p>
        </div>

        <chatbotBtn/>
        <i18n class="pr-5" />
        <profile-drop-down :name="userName" :role="userRole"/>
      </vs-navbar>
    </div>
  </div>
</template>


<script>
import I18n                 from './components/I18n.vue'
import SearchBar            from './components/SearchBar.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'
import HeaderProfile        from './components/HeaderProfile.vue'
import chatbotBtn           from '@/components/chatbot/chatbot-btn.vue'

export default {
  name: 'the-navbar-vertical',
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {
    I18n,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
    HeaderProfile,
    chatbotBtn
  },
  data () {
    return {
      sticking: true,
      hasUnderwritingExecutive: false,
      underwritingExecutiveName: null,
      underwritingExecutiveRole: null,
      hasAreaManager: false,
      areaManagerName: null,
      areaManagerRole: null,
      pageTitle: null,
      userName: null,
      userRole: null,
      underwriterExecutivePk: null,
      areaManagerPk: null,
    }
  },
  computed: {
    EntityName() {
      const user = this.$store.getters['auth/user'];
      return user.company.CompanyName;
    },
    navbarColorLocal () {
      return '#242424';
      // return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#262626' : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return {'text-white': (this.navbarColor !== '#262626' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj () {
      if      (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth)               return 'navbar-full'
    }
  },
  methods: {
    handleStickyNav (event) {
      const el = this.$refs.stickyNav;
      const observer = new IntersectionObserver(
          ([e]) => e.target.classList.toggle('sticking', e.intersectionRatio < 1),
          {threshold: [1]}
      );

      observer.observe(el);
    },
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    },
    async setHeaderInfo() {
      const headerInfo = await this.$api.headerInfo.list();

      this.hasUnderwritingExecutive = headerInfo.data.HasUnderwritingExecutive;
      this.underwritingExecutiveName = headerInfo.data.UnderwritingExecutiveName;
      this.underwritingExecutiveRole = headerInfo.data.UnderwritingExecutiveRole;
      this.hasAreaManager = headerInfo.data.HasAreaManager;
      this.areaManagerName = headerInfo.data.AreaManagerName;
      this.areaManagerRole = headerInfo.data.AreaManagerRole;
      this.pageTitle = headerInfo.data.PageTitle;
      this.userName = headerInfo.data.UserName;
      this.userRole = headerInfo.data.UserRole;
      this.underwriterExecutivePk = headerInfo.data.UnderwriterExecutivePk;
      this.areaManagerPk = headerInfo.data.AreaManagerPk;
    }
  },
  created () {
    window.addEventListener('scroll', this.handleStickyNav);
    this.setHeaderInfo();
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleStickyNav);
  },
}
</script>

<style lang="scss">
.navbar-floating {
  .vx-navbar-wrapper {
    padding: 0;
    width: 100% !important;
    height: auto;
    position: initial;
  }

  .sticky-nav {
    position: sticky;
    top: -1px;
    z-index: 100;

    .entity-name {
      width: 100%;
      text-align: center;
      font-size: 20px;
      color: #fff;

      // @media (max-width: 576px) {
      //   width: 100%;
      // }
    }

    .vx-navbar {
      border-radius: 0;
      padding: 1.4rem 2rem;
    }

    &.sticking {
      .entity-name {
        font-size: 15px;
      }

      .vx-navbar {
        padding: 1rem .7rem;
      }
    }

    @media (max-width: 1199px) {
      // .entity-name {
      //   width: fit-content;
      //   position: inherit;
      // }

      .vx-navbar {
        padding: 1rem .7rem;
      }
    }

    @media (max-width: 576px) {
      .vertical-spacer {
        display: none;
      }
    }
  }
}

.navbar-custom {
  .vs-con-items {
    justify-content: flex-end;
  }
}
</style>
